<template>
  <BaseLayout>
    <div class="page-single position-relative">
      <b-container
        fluid
      >
        <b-row class="justify-content-center">
          <b-col class=" col-sm-8 col-md-7 col-lg-5 col-xl-3">
            <b-form
              class="card"
              @submit.prevent="confirm"
            >
              <div class="card-body p-6">
                <div
                  class="card-title"
                  style="font-size: 24px;"
                >
                  Forgotten your password?
                </div>
                <b-form-group
                  id="email-address-group"
                  label="Email address*"
                  label-for="email-address-input"
                  label-class="form-label"
                >
                  <b-form-input
                    id="email-address-input"
                    v-model="email"
                    required
                    placeholder="Enter email"
                    autocomplete="off"
                    data-test="email-input"
                    autofocus
                    type="email"
                    @blur.native="onBlurEmail"
                    :class="[emailValid ? '' : 'is-invalid']"
                  />
                  <p
                    v-if="!emailValid"
                    class="invalid"
                  >
                    Please enter a valid email address
                  </p>
                </b-form-group>
                <div class="form-footer">
                  <button
                    type="submit"
                    class="btn btn-primary btn-block"
                    :disabled="isDisabled"
                    data-test="forgot-password-submit"
                    :class="{ 'btn-loading': isLoading }"
                  >
                    Reset Password
                  </button>
                </div>
                <br>
                <div class="text-center text-muted">
                  Already have an account?
                  <router-link
                    :to="this.$route.query.redirect
                      ?`login?redirect=${this.$route.query.redirect}`:`login`"
                  >
                    Log in
                  </router-link>
                </div>
              </div>
            </b-form>
            <div class="text-center text-muted mt-4">
              Need support? Contact our team <a
                href="mailto:support@smartology.net"
                target="_blank"
              >support@smartology.net</a>
            </div>
          </b-col>
        </b-row>
        <div
          class="header-brand d-flex justify-content-center mb-5 mr-0 smartology-logo-footer"
          style="z-index: 0;"
        >
          <a
            target="_blank"
            href="https://www.smartology.net/"
          >
            <img
              src="/images/logo.png"
              class="h-7 header-brand-img mr-0"
              alt="Smartology"
            >
          </a>
        </div>
      </b-container>
    </div>
  </BaseLayout>
</template>

<script>
import signUtils from '@/core/signUtils';
import { mapActions } from 'vuex';
import * as types from '@/modules/authentication/store/types';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      clicked: false,
      isLoading: false,
      emailValid: true,

    };
  },
  computed: {
    isDisabled() {
      return !this.email || (this.email && !signUtils.isEmailValid(this.email));
    },
  },
  methods: {
    ...mapActions('authentication', [
      types.FORGOT_PASSWORD,
    ]),
    confirm() {
      if (this.clicked) return;
      this.clicked = true;
      this.isLoading = true;
      this.FORGOT_PASSWORD(this.email)
        .then(() => {
          this.clicked = false;
          this.isLoading = false;
        })
        .catch(() => {
          this.clicked = false;
          this.isLoading = false;
        });
      this.$router.push('/verify-forgotten-password');
    },
    onBlurEmail() {
      this.emailValid = !this.email || signUtils.isEmailValid(this.email);
    },
  },
};
</script>
